export default __webpack_public_path__ + "static/media/creative-agenct.9e550777.png";